import React from 'react';

import UsersModal from '../../../containers/authorization/users/UsersModal';
import UsersTablePane from '../../../containers/authorization/users/UsersTablePane';

const UsersTabPane = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <UsersTablePane />
      <UsersModal />
    </div>
  );
};

export default UsersTabPane;
